import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ReportTaskPageRoutingModule } from "./report-task-routing.module";

import { ReportTaskPage } from "./report-task.page";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../../../_component/header/header.module";
import { PaginationClientSideModule } from "../../_component/pagination-client-side/pagination-client-side.module";
import { ReportTaskViewModule } from "../report-task-view/report-task-view.module";
import { SearchBarModule } from "../../_component/search-bar/search-bar.module";
import { NoResultModule } from "src/app/app/_component/no-result/no-result.module";
import { AddReportTaskPageModule } from "./add-report-task/add-report-task.module";
import { EditReportTaskPageModule } from "./edit-report-task/edit-report-task.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { MatRadioModule } from "@angular/material/radio";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { ListHeaderComponentModule } from "../../_component/_structural/list-header/list-header.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ReportTaskPageRoutingModule,
    TranslateModule,
    HeaderModule,
    PaginationClientSideModule,
    ReportTaskViewModule,
    SearchBarModule,
    NoResultModule,
    AddReportTaskPageModule,
    EditReportTaskPageModule,
    SharedDirectivesModule,
    LoadingStiModule,
    MatRadioModule,
    SelectDropdownModule,
    BreadcrumbComponentModule,
    ListHeaderComponentModule,
  ],
  declarations: [ReportTaskPage],
})
export class ReportTaskPageModule {}
